module.exports = __webpack_public_path__ + "img/linear_channel.a009cbd8.png";